// components/CustomSelectDropdown.jsx
import { Listbox } from "@headlessui/react";
//import { useState } from "react";

export default function SelectDropdown({ options, selected, onChange, position = "below" }) {
  return (
    <div className="w-full">
      <Listbox value={selected} onChange={onChange}>
        <div className="relative mt-1">
          <Listbox.Button className="w-full cursor-pointer rounded-md border border-gray-300 py-2 px-3 text-left">
            {selected?.label || "Select..."}
          </Listbox.Button>
          
          <Listbox.Options
            className={`absolute max-h-60 w-full overflow-auto rounded-md bg-white shadow-lg z-10
              ${position === "above" ? "bottom-full mb-1" : "top-full mt-1"}`}
          >            
          {options.map((option, index) => (
              <Listbox.Option
                key={index}
                value={option}
                className={({ active, selected }) =>
                  `cursor-pointer select-none py-2 px-4 ${
                    selected ? "bg-orange-200" : ""
                  } ${active ? "bg-orange-100" : ""}`
                }
              >
                {option.label}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </div>
      </Listbox>
    </div>
  );
}
